import styles from './index.module.scss';
import Image from "next/image";

// Radio button options
const options = [
    'Bank Account Opening',
    'Visa Support',
    'External Approvals',
    'Office',
    'Tax Registration and Filing',
    'Compliance',
    'Other'
];

export default function AdditionalServices({data, onChange}) {
    const selectService = (service) => {
        if (data.additional_services.includes(service)) {
            onChange('additional_services', data.additional_services.filter(s => s !== service));
        } else {
            onChange('additional_services', [...data.additional_services, service]);
        }
    }
    return (
        <div className={styles.container}>
            <h2>Would you like assistance with any of the following?</h2>
            <div className={styles.services}>
                {
                    options.map((service, index) => (
                        <div key={index}
                             className={`${styles.service} ${data.additional_services.includes(service) && styles.active}`}
                             onClick={() => selectService(service)}>
                            {service}
                        </div>
                    ))
                }
            </div>
        </div>
    )
}